export default defineNuxtPlugin(async app => {
    const enabled = useKeepFilters();
    async function refresh() {
        try {
            const settings = await $fetch<{ keepFiltersEnabled: boolean }>('/api/plp-settings');
            enabled.value = settings.keepFiltersEnabled === true;
        } catch {
            enabled.value = false;
        }
    }
    // Hydrate the server state first. Recheck afterwards so cached HTML cannot
    // keep a disabled feature active for the lifetime of the page cache.
    if (import.meta.client && app.isHydrating) {
        app.hook('app:mounted', refresh);
        return;
    }
    await refresh();
});
